
  window.themeCartDisplayCount = {
    showCartCount: true,
    effectiveFreeGift: true,
  };

  window.getCartBubbleDisplayCount = function (cart) {
    var rules = window.themeCartDisplayCount || {};
    if (!rules.showCartCount) return 0;
    if (!cart || typeof cart.item_count !== 'number') return 0;
    var base = cart.item_count;
    if (window.freeGiftDisabled) {
      var sum = 0;
      (cart.items || []).forEach(function (item) {
        if ((item.product_type || '') !== 'free_gift') sum += item.quantity || 0;
      });
      return sum;
    }
    if (!rules.effectiveFreeGift) return base;
    var hasFreeGift = (cart.items || []).some(function (item) {
      return (item.product_type || '') === 'free_gift';
    });
    return hasFreeGift ? base : base + 1;
  };

  window.applyCartBubbleCountFromCart = function (cart) {
    var count = window.getCartBubbleDisplayCount(cart);
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    var span = bubble.querySelector('span[aria-hidden="true"]');
    if (!span) return;
    if (count > 0 && count < 100) {
      span.textContent = String(count);
      bubble.style.display = '';
    } else if (count >= 100) {
      span.textContent = '';
      bubble.style.display = '';
    } else {
      span.textContent = '';
      bubble.style.display = 'none';
    }
  };
